<script lang="ts">
  import {
    connected,
    isLoading,
    requiresTap,
    selectedGame,
    showController,
    showSample,
    showConfig,
    status,
    timer,
    gameScore,
    connectServer,
    invalidToken,
    browserInfo,
    gameAudio,
    gameAudioTrack,
    // controllerConnected,
  } from './components/stores';

  import Loader from './components/Loader.svelte'; // Adjust and use as a stream connection preloader
  import Portrait from './components/Portrait.svelte'; // Forces the user to stay in landscape mode

  // import Gamepad from './components/Gamepad.svelte'; // Taariq's original controller
  import Gamepad from './components/Controller.svelte';
  import Sample from './components/Sample.svelte';
  import Sidebar from './components/Sidebar.svelte';
  import Reemo from './components/Reemo.svelte';
  import WebSocketAndRtcClient, { startSound } from './lib/WebSocket';
  import GameOverlay from './components/GameOverlay.svelte';
  import TapToStartOverlay from './components/TapToStartOverlay.svelte';
  import Score from './components/modals/ScoreModal.svelte';
  import UrlParamManager from './lib/UrlParamManager';
  import InvalidTokenModal from './components/modals/InvalidTokenModal.svelte';
  import Platform from 'platform';
  import { get } from 'svelte/store';
  import BlueToothController from './lib/BlueToothController';
  import QualityController from './components/QualityController.svelte';
  import { WebRTCTest } from './lib/WebRTCTest';

  let sidebar_show = false;
  let wsrtc = new WebSocketAndRtcClient();
  let scale = 1;
  let showTimer = false;

  new BlueToothController(wsrtc);

  var testClient;
  console.log('here');

  wsrtc.setConnectHandler(() => {
    $isLoading = false;
    $showController = true;
    $connected = true;
    showTimer = true;

    console.log('trying to enable sound here');
    try {
      // const audioEl = document.getElementById('audioCtl') as HTMLAudioElement;
      // audioEl.srcObject = get(gameAudioTrack);
    } catch (error) {
      console.log('could not set audio', error);
    }
  });

  wsrtc.setDisconnectHandler(() => {
    console.log('disconnected');
    $status = 'disconnected';
    $showController = false;
    $connected = false;
    timer.updateTime(0);

    setTimeout(() => ($isLoading = false), 500);
  });

  wsrtc.setTimerUpdateHandler((time: number) => {
    timer.updateTime(time);
  });

  //@ts-ignore
  getIPs().then((res) => {
    console.log('platform', Platform.name, Platform);
    browserInfo.set({
      ipAddress: res.join('\n').toString(),
      meta: Platform.toString(),
    });

    console.log('browserinfo:', get(browserInfo));
  });

  setTimeout(() => {
    connectServer.subscribe((serverUri) => {
      if (serverUri) {
        console.log('launching');
        wsrtc.initWebSocket(serverUri);
        const randomString = Math.random().toString(36).substring(2, 10);
        testClient = WebRTCTest.getInstance(wsrtc, randomString);
        console.log('postlaunch');
      } else {
        wsrtc.disconnect();
      }
    });
  }, 0);

  UrlParamManager.HandleUrlParams();
  wsrtc.initPeerConnection();

  function connectController() {
    console.log('here in connect controller');

    try {
      var audioTrack = get(gameAudioTrack);
      console.log('audio track', audioTrack);
      if (audioTrack) {
        const audioEl = document.getElementById(
          'audioCtl2'
        ) as HTMLAudioElement;
        audioEl.srcObject = audioTrack;
      }
      $gameAudio.play();
    } catch {
      console.log('error playing audio');
    }
    setTimeout(() => {
      document.getElementById('reemodiv').click();
    }, 50);
    //const blue = new BlueToothController(wsrtc);
  }

  function handleConnect(event) {
    startSound();
    if (event.detail.event === 'connect') {
      const message = event.detail.value === false ? false : true;
      console.log('handling connect', message);
      connectClient(message);
      $status = 'connecting';
      $isLoading = true;
    }
  }

  function handleRetry() {
    wsrtc.resetGame();
  }

  function connectClient(message: boolean) {
    console.log('connect client message', message, $selectedGame);
    if (message) {
      wsrtc.unmute();
      wsrtc.startGame();
    } else {
      wsrtc.disconnect();
    }
  }

  function handleMessage(event) {
    wsrtc.sendEvent(event.detail.event, event.detail.value);
  }

  function downscale() {
    scale++;
    wsrtc.websocket.send(
      JSON.stringify({ type: 'downscale', value: scale % 3 })
    );
  }
</script>

<svelte:head>
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
  />
  <link
    href="https://fonts.googleapis.com/css?family=Montserrat:400,500,700,900&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<preference name="AllowInlineMediaPlayback" value="true" />

<main id="main">
  <div style="visibility:hidden">
    <audio autoplay controls id="audioCtl" />
    <audio autoplay controls id="audioCtl2" />
  </div>
  <!-- Only visible if config param exist in url (e.g. url?config) -->
  <div class="top-right-section">
    {#if $showConfig}
      <div class="downscale" on:click|preventDefault={downscale}>
        <button style="width:100%; white-space:nowrap">Toggle Quality</button>
      </div>
      <div class="toggle-debugger">
        <button on:click|preventDefault={() => (sidebar_show = !sidebar_show)}
          >Config</button
        >
      </div>
    {/if}
    <!-- <QualityController /> -->
  </div>

  <audio id="audio-element" />

  {#if $showSample}
    <Sample />
  {:else}
    <div id="reemodiv" />
    <Reemo on:message={handleConnect} />
  {/if}

  {#if $status !== 'connecting'}
    <GameOverlay on:message={handleConnect} />
  {/if}

  {#if $showController}
    <Gamepad on:message={handleMessage} visible={!$isLoading} />
  {/if}

  {#if $gameScore.time > 0}
    <Score on:retry={handleRetry} />
  {/if}

  {#if $invalidToken}
    <InvalidTokenModal />
  {/if}
</main>

{#if $requiresTap}
  <TapToStartOverlay on:message={() => connectController()} />
{/if}

<Sidebar bind:show={sidebar_show} />
<!-- Sidebar Menu for Debugging -->
<Portrait />

<Loader />

<style>
  main {
    padding: 0em;
    margin: 0 0;
    height: 100%;
    touch-action: none;
    /* display:none */
  }

  .downscale {
    margin-right: 1rem;
  }

  #reemodiv {
    z-index: 0;
    /* opacity: 0.5; */
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    touch-action: none;
  }

  .top-right-section {
    align-items: center;
    display: flex;
    justify-content: end;
    position: absolute;
    right: 10px;
    top: 0;
    width: auto;
    z-index: 2003;
  }

  :global(*) {
    /* Try disable pinch to zoom */
    touch-action: none !important;
  }
  /* Global Styles */
  :global(body) {
    font-family: 'Montserrat', Arial, sans-serif;
    font-style: normal;
    font-variant: normal;
    font-weight: 400;
    line-height: 1.6rem;
    font-size: 1rem;
    text-align: center;
    background-color: #000000;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    padding: 0;
    transition: all 0.3s;
    /* touch-action: manipulation; */

    /* Try disbale text select */
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  }
  /* Make this dynamic with store variable */
  :global(video) {
    pointer-events: none; /* Try disable pinch to zoom */
    object-fit: contain !important; /* Set to cover to fill the screen */
  }

  :global(button) {
    margin: 10px 0 10px 10px;
    font-weight: 500;
    font-size: 0.8rem;
  }
  :global(select) {
    margin: 10px 0 10px 10px;
    font-weight: 500;
    font-size: 0.8rem;
  }
</style>
